import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { CommonService } from '../../../shared/services/common.service';
import { AuthService } from '../../auth/services/auth.service';
import { ProfileServiceService } from '../profile-service.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss'
})
export class UserProfileComponent implements OnInit {

  isEditing = false;
  oldPasswordVisible = false;
  newPasswordVisible = false;
  confirmPasswordVisible = false;
  apiCallLoader = { isSubmitLoading: false }
  profileForm!: FormGroup;
  passwordForm!: FormGroup;
  preferencesForm!: FormGroup;

  profileData =[] as any;
  displayName = '';
  displayEmail = '';

  constructor(
    protected _location: Location,
    private fb: FormBuilder,
    private message: NzMessageService,
    private router: Router,
    public route: ActivatedRoute,

    private profileSvc: ProfileServiceService,
  ) { }
  ngOnInit() {
    this.getProfileData();
    this.initializeForms();
  }
  initializeForms() {
    this.profileForm = this.fb.group({
      user_id: [localStorage.getItem('user_id')],
      first_name: [this.profileData.first_name || '', [Validators.required]],
      last_name: [this.profileData.last_name || '', [Validators.required]]
    });

    this.passwordForm = this.fb.group({
      email: [this.profileData.email || this.profileData.emailID || ''],
      oldPassword: ['', [Validators.required, Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$')]],
      newPassword: ['', [Validators.required, Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$')]],
      confirmPassword: ['', [Validators.required]]
    }, { validators: [this.passwordMatchValidator, this.oldNewPasswordValidator]});
    this.passwordForm.get('oldPassword')?.valueChanges.subscribe(() => {
      this.passwordForm.get('newPassword')?.updateValueAndValidity();
    });
    this.passwordForm.get('newPassword')?.valueChanges.subscribe(() => {
      const confirmPasswordControl = this.passwordForm.get('confirmPassword');
      if (confirmPasswordControl?.touched) {
        confirmPasswordControl.updateValueAndValidity();
      }
    });
    this.preferencesForm = this.fb.group({
      user_id: [localStorage.getItem('user_id')],
      tempPreference: ['', Validators.required],
    });
  }

  getProfileData()
  {
    const user_id = localStorage.getItem('user_id') || '';
    const payload = { user_id: user_id };
    this.profileSvc.getProfileData(payload).pipe(untilDestroyed(this)).subscribe((response) => {
      if (response?.data && response?.status === 200) {
        this.profileData = response?.data[0];
        const fullName = this.profileData.name || '';
        const firstName = this.profileData.first_name || fullName.split(' ').slice(0, 1).join(' ');
        const lastName = this.profileData.last_name || fullName.split(' ').slice(1).join(' ');
        const email = this.profileData.email || this.profileData.emailID || '';

        this.displayName = [firstName, lastName].filter(Boolean).join(' ').trim() || fullName || '-';
        this.displayEmail = email || '-';

        this.profileForm.patchValue({
          first_name: firstName,
          last_name: lastName,
          email: email,
        });

        this.passwordForm.patchValue({
          email: email
        });
      } else {
        this.message.error(response.message);
      }
    });
  }
  // profileData = {
  //   firstName: this.response.data.first_name,
  //   lastName: response.data.last_name,
  //   email: response.data.email,
  //   contact: response.data.contact,
  //   role: response.data.role_name
  // };
  passwordMatchValidator(g: FormGroup): void {
    const newPassword = g.get('newPassword');
    const confirmPassword = g.get('confirmPassword');
    if (!newPassword || !confirmPassword) return;
    if (confirmPassword.touched) {
      if (newPassword.value !== confirmPassword.value) {
        confirmPassword.setErrors({ passwordMismatch: true });  // ✅ Set error on confirmPassword
      } else {
        confirmPassword.setErrors(null);  // ✅ Clear error when matching
      }
    }
  }
  oldNewPasswordValidator(g: FormGroup): void {
    const oldPassword = g.get('oldPassword');
    const newPassword = g.get('newPassword');
    if (!oldPassword || !newPassword) return;
    if (oldPassword.value && newPassword.value) {
      if (oldPassword.value === newPassword.value) {
        newPassword.setErrors({ sameAsOld: true });  // Error if exactly the same
      } else {
        const currentErrors = newPassword.errors;
        if (currentErrors) {
          delete currentErrors['sameAsOld'];
          if (Object.keys(currentErrors).length === 0) {
            newPassword.setErrors(null);  // Clear errors if none left
          } else {
            newPassword.setErrors(currentErrors);
          }
        }
      }
    }
  }
  onProfileSubmit()
  {

  }
  onPasswordSubmit()
  {

  }
  onPreferencesSubmit()
  {

  }
}
